export default __webpack_public_path__ + "static/media/14.5b53bea8.jpg";